<template>
  <div class="home-scetion">
    <div class="class-banner-wrap">
      <img src="@/image/classCenter/img.png" alt width="100%" />
    </div>
    <div class="class-container_menu">
      <div class="class_menu-section">
        <el-menu class="el-menu-vertical-demo" active-text-color="#fa9241">
          <el-menu-item index="1" @click="getRecommendDataShow()">
            <span>推荐课件</span>
          </el-menu-item>
          <el-submenu index="2">
            <template slot="title">
              <span>三/四年级</span>
            </template>
            <el-menu-item
              v-for="(item, index) in season"
              :key="index"
              :index="2 + '-' + (index + 1)"
              @click="getClassDataShow([3, 4], index + 1)"
              >{{ item }}</el-menu-item
            >
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <span>五/六年级</span>
            </template>
            <el-menu-item
              v-for="(item, index) in season"
              :key="index"
              :index="3 + '-' + (index + 1)"
              @click="getClassDataShow([5, 6], index + 1)"
              >{{ item }}</el-menu-item
            >
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">
              <span>七/八年级</span>
            </template>
            <el-menu-item
              v-for="(item, index) in season"
              :key="index"
              :index="4 + '-' + (index + 1)"
              @click="getClassDataShow([7, 8], index + 1)"
              >{{ item }}</el-menu-item
            >
          </el-submenu>
        </el-menu>
      </div>
      <div class="main-show_container" v-loading="loading">
        <div class="temporary_show-container" v-if="classData.length === 0">
          暂无数据
        </div>
        <div class="main-show_section_list">
          <div class="main-show_item" v-for="item in classData" :key="item.id">
            <router-link
              class="main-show_item_image"
              :to="{ name: 'courseware_data', params: { id: item.id } }"
            >
              <img :src="item.image.file_src" width="100%" />
              <div class="main-show_item-text">
                <p class="main-show_item-title">{{ item.name }}</p>
                <p class="main-show_item-description">{{ item.content }}</p>
              </div>
            </router-link>
            <div class="main-show_item-handle">
              <el-button
                plain
                icon="el-icon-download"
                size="small"
                @click="downLoad(item.file, item.id)"
                >下载课件包</el-button
              >
              <el-button
                type="primary"
                size="small"
                :plain="true"
                v-if="item.is_subscribed"
                >已订阅</el-button
              >
              <el-button
                type="primary"
                size="small"
                :plain="false"
                @click="handleSubscribe(item)"
                v-else
                >订阅
              </el-button>
            </div>
          </div>
        </div>
        <div class="paging-container">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="pageSize"
            :current-page="currentPage"
            :total="total"
            @current-change="editCurrentPage"
            :hide-on-single-page="true"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import classRequest from "@/global/service/class";

export default {
  data() {
    return {
      grade: [],
      seasonIndex: null,
      classData: [],
      season: ["春季", "夏季", "秋季", "冬季"],
      pageSize: 9,
      pageCount: null,
      total: null,
      currentPage: 1,
      loading: false
    };
  },
  created() {
    this.getRecommendData();
  },
  methods: {
    handleSubscribe(item) {
      classRequest.coursewareIdSub(item.id).then(() => {
        item.is_subscribed = true;
        this.$message.success("订阅成功");
      });
    },
    editCurrentPage(current) {
      this.currentPage = current;
      this.getData();
    },
    downLoad(item, id) {
      classRequest.coursewareDownload(id).then(() => {
        const el = document.createElement("a");
        document.body.appendChild(el);
        el.href = item.file_src;
        el.download = item.file_name;
        el.target = "_blank";
        el.click();
        document.body.removeChild(el);
      });
    },
    getRecommendData() {
      this.loading = true;
      const params = {
        page: this.currentPage,
        page_size: this.pageSize
      };
      classRequest
        .coursewareRecommend(params)
        .then(res => {
          this.classData = res.list;
          this.total = res.pagination.total;
          this.currentPage = res.pagination.current_page;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getData() {
      if (this.grade && this.seasonIndex) {
        this.getClassData();
      } else {
        this.getRecommendData();
      }
    },
    getRecommendDataShow() {
      this.currentPage = 1;
      this.getRecommendData();
    },
    getClassDataShow(grade, season) {
      this.grade = grade;
      this.seasonIndex = season;
      this.currentPage = 1;
      this.getClassData();
    },
    getClassData() {
      this.loading = true;
      const params = {
        grade_id: this.grade,
        season_id: this.seasonIndex,
        page: this.currentPage,
        page_size: this.pageSize
      };
      classRequest
        .coursewareList(params)
        .then(res => {
          this.classData = res.list;
          this.total = res.pagination.total;
          this.currentPage = res.pagination.current_page;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.class-banner-wrap {
  min-width: 960px;
}
.class-container_menu {
  display: flex;
  width: 70%;
  min-width: 960px;
  padding: 20px 0;
  margin: 0 auto;
  overflow: hidden;
  .class_menu-section {
    flex: none;
    width: 227px;
    /deep/ .el-submenu .el-menu-item.is-active {
      border-left: 2px solid #fa9241;
    }
  }
  .main-show_container {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 16px;
    .main-show_section_list {
      display: flex;
      flex-wrap: wrap;
      .main-show_item {
        padding: 10px 0;
        width: 230px;
        overflow: hidden;
        position: relative;
        border: 1px solid #dedede;
        border-radius: 3px;
        margin: 0 16px 16px 0;
        background: #fff;
        list-style-type: none;
        font-size: 12px;
        text-decoration: none;
        color: #333;
        img {
          object-fit: cover;
          width: 220px;
          height: 220px;
        }
        .main-show_item-text {
          text-align: left;
          font-size: 12px;
          padding: 10px;
          p {
            margin-bottom: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .main-show_item-handle {
          display: flex;
          justify-content: center;
        }
      }
    }
    .paging-container {
      text-align: center;
    }
  }
}
</style>
